import { useState } from 'react';

const INITIAL_PROFILE = {
  name: '', email: '', phone: '', organization_name: '',
  position: '', department: '', organization_type: '',
  years_experience: 0, involvement_level: '', main_problem: '',
  industry: '', industry_other: '', primary_function: '',
};

const INITIAL_AWASI = {
  domain1: [3, 3, 3, 3, 3], domain2: [3, 3, 3, 3, 3],
  domain3: [3, 3, 3, 3, 3], domain4: [3, 3, 3, 3, 3],
};

const INITIAL_EXTENDED = {
  e1: [3, 3, 3], e2: [3, 3, 3], e3: [3, 3, 3], e4: [3, 3, 3],
};

const blankWorkflow = (slotId) => ({
  slotId, name: '', is_repetitive: false, is_rule_based: false,
  is_digital_input: false, is_predictable_output: false,
  is_high_volume: false, requires_judgment: false,
});

const INITIAL_WORKFLOWS = [
  blankWorkflow('workflow-slot-1'),
  blankWorkflow('workflow-slot-2'),
  blankWorkflow('workflow-slot-3'),
];

const setScoreAt = (prev, domain, index, value) => ({
  ...prev,
  [domain]: prev[domain].map((v, i) => i === index ? parseInt(value, 10) : v),
});

/**
 * Encapsulates the raw state slices of the assessment form plus the
 * setter wrappers callers use to update them. No validation, no submission.
 */
export function useAssessmentState() {
  const [profile, setProfile] = useState(INITIAL_PROFILE);
  const [awasi, setAwasi] = useState(INITIAL_AWASI);
  const [extended, setExtended] = useState(INITIAL_EXTENDED);
  const [workflows, setWorkflows] = useState(INITIAL_WORKFLOWS);
  const [consent, setConsent] = useState(false);

  const updateAwasi = (domain, index, value) =>
    setAwasi(prev => setScoreAt(prev, domain, index, value));
  const updateExtended = (domain, index, value) =>
    setExtended(prev => setScoreAt(prev, domain, index, value));
  const updateWorkflow = (index, field, value) =>
    setWorkflows(prev => prev.map((wf, i) => i === index ? { ...wf, [field]: value } : wf));

  return {
    profile, setProfile,
    awasi, updateAwasi,
    extended, updateExtended,
    workflows, updateWorkflow,
    consent, setConsent,
  };
}
